export default __webpack_public_path__ + "static/media/english.30741fcf.webp";